import { PaymentRequestDetails } from '../payment-request-details';

type Props = {
  invoiceId: string | undefined;
};
export const RefundsPanel = ({ invoiceId }: Props) => {
  return <PaymentRequestDetails invoiceId={invoiceId} />;
};
